// extracted by mini-css-extract-plugin
export default {"skeletonContainer":"imageWithLoader_skeletonContainer__-VsUe","skeleton":"imageWithLoader_skeleton__rDYjV","divider":"imageWithLoader_divider__C96w6"};